import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

var imagePremium = require('../images/premium.png')

function sortMessages(messages) {
    return messages.sort((a, b) => { return (b.timestamp - a.timestamp) });
};

export default function Messages({ messages }) {
  return (
    <>
      <h2>Messages</h2>
      {sortMessages(messages).map((message, i) =>
        // TODO: format as cards, add timestamp
        <div key={i} className={message.premium ? 'is-premium' : 'no-premium'}>
          <div>
            <span><strong>{message.sender}</strong><img src={imagePremium} className={message.premium ? 'img-premium' : 'img-no-premium'} /></span>
            <span class='time-right'>{moment(new Date(message.timestamp/1000000)).format("YYYY-MM-DD hh:mm:ss")}</span></div>
          <div>{message.text}</div>
        </div>
      )}
    </>
  );
}

Messages.propTypes = {
  messages: PropTypes.array
};
